// 언어 전환 — 앱바(어두운 배경)와 더보기 행 두 자리에서 쓴다. props: { variant: 'bar' | 'row' }
// 저장 키는 I18nProvider 의 autodex_buyer_locale 그대로. 네이티브 select 라 모바일에서도 그대로 동작한다.
import React from 'react';
import { T, R } from '../../theme';
import { useT, useLocale } from '../../../i18n/I18nProvider';

var OPTIONS = [['ko', 'languageKo'], ['en', 'languageEn'], ['ar', 'languageAr'], ['ru', 'languageRu']];

var base = { height: 28, padding: '0 8px', borderRadius: R.md, fontSize: 11.5, fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit', outline: 'none', maxWidth: 140 };
var bar = { border: '1px solid rgba(255,255,255,.18)', background: 'transparent', color: 'rgba(255,255,255,.88)' };
var row = { border: '1px solid ' + T.bd, background: T.card, color: T.body, height: 32, fontSize: 12.5 };
// 펼친 목록은 흰 바탕 — 앱바(어두운) 변형에서 select 색을 그대로 물려받으면 글자가 안 보인다.
var option = { color: T.ink, background: T.card };

function LangSelect(props) {
  var t = useT();
  var loc = useLocale();
  var style = Object.assign({}, base, props.variant === 'row' ? row : bar);
  return (<select className="ss-lang" aria-label={t('simpleLangTitle')} value={loc.locale} style={style}
    onChange={function (e) { loc.setLocale(e.target.value); }}>
    {OPTIONS.map(function (o) { return <option key={o[0]} value={o[0]} style={option}>{t(o[1])}</option>; })}
  </select>);
}

export default LangSelect;
